import React from 'react';

import * as CustomPropTypes from 'lib/CustomPropTypes';
import loadScript from 'lib/loadScript';

import styles from '../styles.module.scss';

export default class GraphiqEmbed extends React.Component {
  static propTypes = {
    widget: CustomPropTypes.widget.isRequired,
  };

  componentDidMount() {
    loadScript('https://s.graphiq.com/rx/widgets.js');
  }

  render() {
    const { widget } = this.props;

    return (
      /* eslint-disable react/no-danger */
      <div
        className={styles.usePresentation}
        dangerouslySetInnerHTML={{ __html: widget.baseline }}
      />
      /* eslint-enable react/no-danger */
    );
  }
}
